class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Event delegation for item removal and quantity editing
    this.notification.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('.cart-notification-item-box__remove');
      if (removeBtn) {
        event.preventDefault();
        const itemKey = removeBtn.getAttribute('data-item-key');
        this.updateQuantity(itemKey, 0);
      }
    });

    this.notification.addEventListener('change', (event) => {
      if (event.target.classList.contains('quantity__input')) {
        const itemKey = event.target.getAttribute('data-item-key');
        this.updateQuantity(itemKey, event.target.value);
      }
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // Update item count badge in the header
    const countElement = document.getElementById('cart-notification-item-count-data');
    if (countElement) {
      const count = countElement.getAttribute('data-item-count');
      const headerCircle = this.notification.querySelector('.cart-notification__item-count-circle');
      if (headerCircle) {
        headerCircle.textContent = count;
        headerCircle.style.display = parseInt(count) > 0 ? 'inline-flex' : 'none';
      }
    }

    // Update subtotal value in the footer
    const subtotalElement = document.getElementById('cart-notification-subtotal-data');
    if (subtotalElement) {
      const subtotal = subtotalElement.getAttribute('data-subtotal');
      const displaySubtotal = document.getElementById('cart-notification-subtotal-value');
      if (displaySubtotal) {
        displaySubtotal.textContent = subtotal;
      }
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  updateQuantity(lineKey, quantity) {
    const body = JSON.stringify({
      id: lineKey,
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.renderContents(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-notification',
          cartData: parsedState,
        });
      })
      .catch((error) => console.error(error));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
